RivalIQ.apps.Admin.module('models', function (models, Admin, Backbone, Marionette, $, _) {

    'use strict';

    models.Query = Backbone.Model.extend({

        urlRoot: '/admin/api/queries',

        exportLink: function (format) {
            const me = this;
            return `${_.result(me, 'url')}?format=${format}`;
        }
    });
});
